import SignInMixin from '@/store/module/signIn/mixin'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'MFA',
  data () {
    return {
      authCode: null
    }
  },
  mixins: [
    SignInMixin
  ],
  created () {
    loading.pop()
  },
  methods: {
    validateAndSignInWithMFA () {
      this.authCode = this.authCode.trim()
      this.$emit('LoginMFA', this.authCode)
    },
    getValidationState (fieldName) {
      const field = this.$validator.fields.find({ name: fieldName })

      if (!field) return null

      const isDirty = field.flags.dirty
      const isValid = !this.errorsVee.has(fieldName)
      return isDirty ? isValid : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/auth/mfa/mfa.js